import {
  BID_STATUSES,
  SHIPMENT_STATUSES,
  SHIPMENT_SUB_STATUSES,
} from 'apps/tms/utils/constants/shipmentStatuses'

/**
 * we're excluding invoicing states to maintain these types backward compatible
 * with existing implementations that rely on this type definition.
 */
type ShipmentStatusLabel =
  | Exclude<
      SHIPMENT_STATUSES,
      SHIPMENT_STATUSES.awaitingReview | SHIPMENT_STATUSES.disputed | SHIPMENT_STATUSES.accepted
    >
  | BID_STATUSES
  | Exclude<SHIPMENT_SUB_STATUSES, SHIPMENT_SUB_STATUSES.invoiced>

// THIS IS DEFINITELY GOING TO BE REFACTORED NEED TO TALK TO JOSH ABOUT THIS
export const SHIPPER_STATUS_LABELS: Record<ShipmentStatusLabel, string> = {
  expired: 'Carrier did not accept',
  carrier_declined: 'Declined',
  placed: 'Submitted',
  locked: 'Submitted',
  lost: 'Submitted',
  carrier_confirmed: 'Accepted',
  pending_carrier_accept: 'Pending Acceptance',
  in_auction_no_bids: 'Did Not Bid',
  auction_ended_bid_selection_required: 'Waiting for Response',
  action_needed: 'Action Needed',
  in_auction: 'Auction in progress',
  canceled: 'Shipment not Available',
  assigning: 'Assigning',
  shipment_canceled: 'Shipment not Available',
  confirmed: 'Assigned',
  in_routing: 'In Routing',
  in_auction_bid_not_accepted: 'Bid Declined',
  in_direct_assignment: 'Direct Tender',
  in_direct_assignment_carrier_decline: 'Carrier Declined',
  in_direct_assignment_no_acceptance: 'Action Needed',
  in_direct_assignment_shipper_canceled: 'Action Needed',
  retracted: 'Bid Retracted',
  draft: 'Draft',
  in_routing_no_acceptance: 'Carrier Declined',
  in_auction_carrier_decline: 'Carrier Declined',
  carrier_bounced: 'Carrier Bounced',
  did_not_bid: 'Carrier did not bid',
  waiting_for_response: 'Wait for Response',
  dispatched: 'Dispatched',
  at_delivery: 'At Delivery',
  at_pickup: 'At Pickup',
  in_transit: 'In Transfit',
  delivered: 'Delivered',
  completed: 'Completed',
}
